import "../index.scss";

import React from "react";
import { connect } from "react-redux";
import Checkbox from "Components/common/Checkbox/Checkbox";

@connect(store => {
    return {}
})

class Subscriptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: []
        }
    }

    componentDidMount() {
        this.setState({...this.state, selected: this.props.selected});
    }

    render() {
        const { dispatch, calendars, view=false} = this.props;
        
        const handleSave = () => {
            dispatch({ type: "UPDATE_SETTINGS_SUBSCRIPTIONS", calendars: this.state.selected });

            $("#subscriptionsViewModal").modal("hide");
        }

        const handleClose = () => {
            this.setState({ ...this.state, selected: this.props.selected });
        }

        return (
            <div class="modal calendar-settings-modal fade bg-overlay" id="subscriptionsViewModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header border-none pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 text-black brndnTxt-m mb0">Calendar Subscriptions</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a class="text-right text-black" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body">
                            {calendars.map(c => {
                                const isSelected = this.state.selected.map(i => i.id).indexOf(c.id) > -1;
                                const handleSelectHoliday = () => {
                                    if(isSelected) {
                                        this.setState({...this.state, selected: this.state.selected.filter(s => s.id !== c.id)});
                                    } else {
                                        this.setState({...this.state, selected: [...this.state.selected, c]});
                                    }
                                }
 
                                return (
                                    <React.Fragment>
                                        {view && <React.Fragment>
                                            {isSelected ? <div class="subscriptionItem">
                                                <p>{c.calendar} - <a onClick={() => this.props.onView(c)}>{(c.calendar_holiday || []).length} Holiday/s</a></p>
                                            </div> : <span></span>}
                                        </React.Fragment>
                                        }
                                        {!view && <div class="subscriptionItem">
                                                <div class="actionItem">
                                                <Checkbox checked={isSelected} onChange={handleSelectHoliday} />
                                                </div>
                                                <p>{c.calendar} - <a onClick={() => this.props.onView(c)}>{(c.calendar_holiday || []).length} Holiday/s</a></p>
                                            </div>
                                        }
                                    </React.Fragment>
                                )
                            })}
                        </div>
                        {!view && 
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 text-align-right">
                                    <button type="button" class="btn btn-cancel" data-dismiss="modal" onClick={handleClose}>Cancel</button>
                                    <button type="button" class="btn btn-blue m0" onClick={handleSave}>Update</button>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}

Subscriptions.defaultProps = {
    calendars: [],
    selected: []
}

export default Subscriptions;
